module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "legals-layout take-place column"
  }, [_c('div', {
    staticClass: "legals-master column"
  }, [_vm._v("\n\t\t\tCGV Works\n\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7663c68c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/Legal/CGV.vue
// module id = 1149
// module chunks = 0